<template>
    <NuxtLink v-if="cont" custom :to="{ name: 'admin-contact-contactId', params: { contactId: cont.id } }"
        v-slot="{ navigate }">
        <div class="w-full p-2 flex flex-col items-center justify-center border rounded-md hover:shadow-lg cursor-pointer"
            @click="$store.settings.addContactSearch(cont.id); navigate()">
            <Picture :size="9" :src="cont.photo" />
            <div class="text-center">
                {{ cont.firstname }}
                {{ cont.lastname }}
            </div>
            <div v-if="cont.birthname" class="text-center">
                 ({{ cont.birthname }})
            </div>
            <div v-if="cont.referrer" class="text-center">
                 |&nbsp;{{ cont.referrer }}
            </div>
        </div>
    </NuxtLink>
</template>

<script lang="ts">
import { IContact } from '~/api/myedvenn/contact';

export default defineComponent({
    props: {
        contact: [Object, Number] as PropType<IContact | number>
    },
    setup(props) {
        const { $api } = useNuxtApp()

        const cont = ref<IContact>()

        watch(() => props.contact, (c) => {
            if (typeof c === 'number')
                $api.contact.get({ id: c })
                    .then(_c => cont.value = _c)
            else
                cont.value = c
        }, { immediate: true })

        return {
            cont
        }
    }
})
</script>